/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Evidenceinlinedismisstitle3Inputs */

const en_evidenceinlinedismisstitle3 = /** @type {(inputs: Evidenceinlinedismisstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss this suggestion`)
};

const pt_evidenceinlinedismisstitle3 = /** @type {(inputs: Evidenceinlinedismisstitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispensar esta sugestão`)
};

/**
* | output |
* | --- |
* | "Dismiss this suggestion" |
*
* @param {Evidenceinlinedismisstitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const evidenceinlinedismisstitle3 = /** @type {((inputs?: Evidenceinlinedismisstitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Evidenceinlinedismisstitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_evidenceinlinedismisstitle3(inputs)
	return pt_evidenceinlinedismisstitle3(inputs)
});
export { evidenceinlinedismisstitle3 as "evidenceInlineDismissTitle" }